import { useAsyncSearch } from "../../../hooks/useAsyncSearch"
import { Select } from "../Select/Select"

export const AsyncSelect = <T extends Record<string, any>>({
  value,
  options,
  asyncRefetch,
  isAsyncLoading,
  onChange,
  nothingFoundMessage = "No options found",
}: {
  value: string | null
  options: { label: string; value: string }[] | undefined
  asyncRefetch?: (searchQuery?: string) => Promise<T[]>
  isAsyncLoading?: boolean
  onChange: (val: string | null) => void
  nothingFoundMessage?: string
}) => {
  const { searchValue, setSearchValue, inputRef } = useAsyncSearch(
    asyncRefetch,
    options
  )

  return (
    <Select
      searchable
      value={value}
      ref={inputRef}
      autoFocus
      data={options || []}
      searchValue={searchValue}
      onSearchChange={setSearchValue}
      onChange={onChange}
      disabled={isAsyncLoading}
      placeholder={isAsyncLoading ? "Loading..." : "Search and select..."}
      comboboxProps={{
        withinPortal: false,
      }}
      isLoading={isAsyncLoading}
      nothingFoundMessage={nothingFoundMessage}
    />
  )
}
